import { 
	SET_ALGOLIA_SEARCH_HC_PROVIDER, 
	SET_ALGOLIA_SEARCH_USERS,
	SET_PATIENTS_HC_PROVIDER,
	SET_PATIENTS_VIRUSES,
	SET_PATIENTS_DEPENDENTS_VIRUSES,
	SET_CURRENT_PATIENTS,
	SET_DATA_PATIENTS_HC_PROVIDER,
	SET_USER_FOR_ID
} from '../types';

const initialState = {
	algoliaData: {
		virus: [],
		patients: [],
		documents: [],
	},
	patients: [],
	patientViruses: [],
	dependentsViruses: [],
	patientsHcProvider: [],
	currentPatients: {},
	dataPatients: [],
	patientForId: []
};

const appReducer = (state = initialState, action) => {

	switch(action.type) {
		case SET_ALGOLIA_SEARCH_HC_PROVIDER: {
			return {...state, algoliaData: {...state.algoliaData, ...action.payload }};
		}
		case SET_ALGOLIA_SEARCH_USERS: {
			return {...state, ...action.payload };
		}
		case SET_PATIENTS_HC_PROVIDER: {
			return {...state, ...action.payload };
		}
		case SET_PATIENTS_VIRUSES: {
			return {...state, patientViruses: action.payload };
		}
		case SET_PATIENTS_DEPENDENTS_VIRUSES: {
			return {...state, dependentsViruses: action.payload };
		}
		case SET_CURRENT_PATIENTS: {
			return {...state, currentPatients: { ...action.payload } };
		}
		case SET_DATA_PATIENTS_HC_PROVIDER: {
			return {...state, ...action.payload };
		}
		case SET_USER_FOR_ID: {
			return {...state, patientForId: action.payload};
		}
		default: return state;
	};

};

export default appReducer;